module.exports = __webpack_public_path__ + "img/ico-skype.fcc41e6c.svg";